import React, { useCallback, useMemo } from 'react';
import { Timeframe } from '../../../../components/basic/Timeframe';
import { useInput } from '@tradingblock/components';
import _ from 'lodash';
import { ApplicationErrorsDownloadCSV } from './ApplicationErrorsDownloadCSV';
import { GroupedApplicationError } from '@tradingblock/types';

interface ApplicationErrorsFiltersProps {
  search: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  onSave: (startDate: Date | undefined, endDate: Date | undefined) => void;
  onSearchSubmit: (search: string) => void;
  applicationErrors: GroupedApplicationError[];
}

export const ApplicationErrorsFilters: React.FC<ApplicationErrorsFiltersProps> = ({
  search,
  startDate,
  endDate,
  onSave,
  onSearchSubmit,
  applicationErrors,
}) => {
  const [searchValue, setSearchValue, inputProps] = useInput(undefined, { onEnter: onSearchSubmit });

  const currentSearch = useMemo(() => {
    if (!_.isUndefined(searchValue)) {
      return searchValue;
    }
    return search || '';
  }, [search, searchValue]);

  const onClearSearch = useCallback(() => {
    onSearchSubmit('');
    setSearchValue('');
  }, []);

  return (
    <div className="table-toolbar table-toolbar-top">
      <div className="table-toolbar-primary">
        <input
          className="input input-dark input-tall"
          type="text"
          placeholder={'Search...'}
          value={currentSearch}
          {...inputProps}
        />
        {currentSearch && (
          <i
            className="fa fa-times fa-2x"
            onClick={onClearSearch}
            style={{ color: 'var(--blue)', cursor: 'pointer', paddingLeft: '0.32em' }}
          />
        )}
      </div>
      <div className="table-toolbar-secondary">
        <Timeframe
          initialStartDate={startDate}
          initialEndDate={endDate}
          btnClassName="btn-dark btn-tall dropdown-toggle.no-caret text-left"
          placeholderClassName="select__placeholder"
          caret={<i className="fal fa-calendar" />}
          onSave={onSave}
        />
        <ApplicationErrorsDownloadCSV applicationErrors={applicationErrors} />
      </div>
    </div>
  );
};
